module.exports = __webpack_public_path__ + "images/xpms全景_03.jpg?v=4361c563";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue2/xpms全景_03.jpg
 ** module id = 126
 ** module chunks = 1 2
 **/